import type { MarketConfig } from '../../types';

export const academyInIcpConfig = {
  slug: 'aca-in-icp',
  label: 'Academy India',
  country: 'IN',
  language: 'en',
  siteSection: 'ACA_IN',
  cms: 'AzureSWA',
  title: 'Industrial Cybersecurity Professional Career Path | TÜV SÜD Academy India',
  description:
    'Lead generation landing page for the Industrial Cybersecurity Professional (ICP) career path by TÜV SÜD Academy India.',
  themeColor: '#001a3a',
  ogImage: 'https://mango-grass-0099f4103.6.azurestaticapps.net/favicon.png',
  ogImageAlt: 'TÜV SÜD Academy India industrial cybersecurity lead generation landing page preview image',
  twitterCard: 'summary_large_image',
  robots: 'noindex,nofollow',
} satisfies MarketConfig;
